import styled, { keyframes } from 'styled-components';

const DropdownAppearAnimation = keyframes`
  from {
    transform: scale(0);
  }
  to {
    transform: scale(1);
  }
`;

export const Container = styled.div<any>`
  position: ${props => props.optionContainer ? 'relative' : 'absolute'};
  z-index: ${p => p.zIndex ? p.zIndex : 1002};
  background-color: ${p => p.theme.color.backgroundRush};
  box-shadow: ${p => p.theme.shadow.xl};
  box-sizing: border-box;
  max-width: 100%;
  padding: 10px 0;
  border-radius: 20px;
  border: 1px solid ${p => p.theme.color.background};
  overflow: overlay;
  background-color: ${p => p.theme.color.backgroundRush};
  animation: ${p => !p.optionContainer && DropdownAppearAnimation};
  animation-duration: ${p => !p.optionContainer && p.theme.duration.s};
  animation-timing-function: ${p => !p.optionContainer && p.theme.function.oq};
  animation-direction: ${p => !p.optionContainer && 'reverse'};

  p {
    font-family: 'Regular';
    white-space: normal;
  }

  &::-webkit-scrollbar-track {
    margin: 15px 0;
  }

  &::-webkit-scrollbar-thumb {
    background: ${p => p.theme.color.disabled};
  }

  &::-webkit-scrollbar-thumb:hover {
    background: ${p => p.theme.color.gray};
  }

  @media all and (max-height: 555px) {
    height: 200px;
    top: 100px !important;
  }
`;

const Group = styled.div`
  border-top: 1px solid ${p => p.theme.color.background};

  &:first-child {
    border: none;
  }
`;

const Blank = styled.div<any>`
  left: 0px;
  top: 0px;
  width: 100%;
  height: 100%;
  cursor: default;
  position: absolute;
  z-index: ${p => p.zIndex ? p.zIndex - 1 : 900};
`;

export const Styled = {
  Container,
  Group,
  Blank,
};
